"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const MemberSubTypeToolTip = () => (react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: 'Mechanical royalties result from a mechanical license, which is permission to reproduce and distribute a musical work in the form of a physical or digital phonorecord. Examples of this include streaming a musical work on a platform such as Spotify or Apple Music.' }));
exports.default = MemberSubTypeToolTip;
